import React from "react";
import classNames from "classnames";
import { Button, Classes, Popover, AnchorButton, Checkbox} from "@blueprintjs/core";
import styles from "./VideoListTableComponent.module.scss";
import { Icon } from "../../atoms/Icon";
import ShareVideo from "../Share/ShareVideo/ShareVideo";
import appStore from "../../assets/appStore.png";
import googlePlay from "../../assets/googlePlay.png";

const watchVideoButton = (id) => {
  //  We use e.stopPropagation() on the <a> tag to prevent the table row's
  //  onClick event from being fired in this case
  
  return (
    <AnchorButton
      target="_blank"
      href={`${process.env.REACT_APP_WEB_URL}/watch/${id}`}
      onClick={(e) => e.stopPropagation()}
      icon={
        <Icon
          color="#00998c"
          className={styles.watchVideoIcon}
          name="Camera-Broadcast"
        />
      }
      minimal
    >
      Watch Video
    </AnchorButton>
  );
};

const stringRenderer = ({ className, cellData }) => (
  <div className={className}>{cellData}</div>
  );

const videoNameRenderer = ({ className, cellData, rowData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    {rowData.wowzaId && (
      <div className={styles.imageWrapper}>
        <img
          alt="video thumbnail"
          width={41}
          height={41}
          src={rowData.thumbnailUrl}
          className={styles.thumbnail}
        />
      </div>
    )}
    <div className={rowData.wowzaId && styles.videoNameText}>{cellData}</div>
  </div>
);

const watchVideoRenderer = ({ className, cellData }) => (
  <div className={className}>{watchVideoButton(cellData)}</div>
);

const viewsRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Eye-Public" />
    {cellData}
  </div>
);

const ordersRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Orders" />
    {cellData}
  </div>
);

const salesRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <Icon className={styles.tableIcon} name="Cash" /> ${cellData.toFixed(2)}
  </div>
);

const shareRenderer = ({ className, cellData, rowData }) => (
  <div
    className={classNames(
      className,
      styles.cellWrapper,
      styles.iconOnlyWrapper
    )}
  >
    {/* We use e.stopPropagation() on the <div> tag to prevent the table row's
     * onClick event from being fired in this case */}

    <div onClick={(e) => e.stopPropagation()}>
      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
        <Button icon={<Icon name="Share" />} minimal />
        <ShareVideo videoId={cellData} videoUrl={rowData.url} />
      </Popover>
    </div>
  </div>
);

const startBroadcastRenderer = ({ rowData }) =>
  !!rowData.wowzaId ? (
    watchVideoButton(rowData.id)
  ) : (
    <div onClick={(e) => e.stopPropagation()}>
      {/* We use e.stopPropagation() on the <div> tag to prevent the table row's
       * onClick event from being fired in this case */}
      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
        <Button icon={<Icon name="mobile-video" color="#00998c" />} minimal>
          Start Broadcast
        </Button>

        <div className={styles.scheduleBroadcast}>
          <div className={styles.scheduleTitle}>Download the mobile app</div>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <div className={styles.scheduleIcons}>
            <div>
              <a
                href="https://apps.apple.com/us/app/zipline-live-new/id1477631936?ls=1"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.btnDownloadApp}
              >
                <img src={appStore} alt="" />
              </a>
            </div>

            <div style={{ paddingLeft: "11px" }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.zipline.native&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.btnDownloadApp}
              >
                <img src={googlePlay} alt="" />
              </a>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );

const unarchiveRenderer = ({ className, cellData, rowData }) => {
 
 const unArchive = ()=>{
   rowData.onUnarchiveVideo(rowData);
 }

  return(
  <div
    className={classNames(
      className,
      styles.cellWrapper,
      styles.iconOnlyWrapper
    )}
  >
    {/* We use e.stopPropagation() on the <div> tag to prevent the table row's
      * onClick event from being fired in this case */}

    <div onClick={(e) => e.stopPropagation()}>
        <Button icon={<Icon name="unarchive"/>}  onClick = {unArchive} minimal />
        </div>
  </div>);
}
const reportingRenderer = ({ className, cellData, rowData }) => {
  const addToReport = ()=>{
    rowData.onAddToReport(rowData);
  }

  return(
  <div
    className={classNames(
      className,
      styles.cellWrapper,
      styles.iconOnlyWrapper
    )}
  >
    {/* We use e.stopPropagation() on the <div> tag to prevent the table row's
      * onClick event from being fired in this case */}

    <div onClick={(e) => e.stopPropagation()}>
        <Checkbox checked={rowData.includeInReport} onChange= {addToReport}/>
    </div>
  </div>
);
}
  
  
const renderers = {
  string: stringRenderer,
  name: videoNameRenderer,
  id: watchVideoRenderer,
  viewCount: viewsRenderer,
  orderCount: ordersRenderer,
  salesMade: salesRenderer,
  share: shareRenderer,
  startBroadcast: startBroadcastRenderer,
  unarchive: unarchiveRenderer,
  reporting:reportingRenderer
};

const Cell = () => (cellProps) => {
  const format = cellProps.column.key || "string";
  const renderer = renderers[format] || renderers.string;

  return renderer(cellProps);
};

const components = () => ({
  TableCell: Cell()
});

export default components;
